import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import _ from 'lodash';
import { DateTime } from 'luxon';

import Eye from 'components/Icons/Eye';
import i18n from 'translations/i18n';
import TitleLabel from 'components/TitleLabel/TitleLabel';

import './PrintSubjects.scoped.scss';

type TSubject = Array<{
  teaching_structure_id: string;
  subject: { name: string; icon?: string; id: string };
  teaching_structure: { title: string };
}>;
const PrintSubjects: React.FC<{ subjects: TSubject }> = ({ subjects }) => {
  const [groupedSubjects, setGroupedSubjects] = useState({});
  useEffect(() => {
    setGroupedSubjects(_.groupBy(subjects, obj => obj.teaching_structure.parent.title));
  }, [subjects]);

  const getFormatedDate = date => {
    if (DateTime.now().diff(DateTime.fromISO(date), 'days').get('days') > 1) {
      return DateTime.fromISO(date).setLocale(i18n.language).toFormat('dd/MM/yyyy');
    }
    return DateTime.fromISO(date).setLocale(i18n.language).toRelative();
  };

  const getClassName = elements => {
    let title;

    elements.map(el => {
      title = el.teaching_structure.parent.title;
      return title;
    });

    return title;
  };

  return (
    <div className="lessons-list-border-bottom">
      {Object.keys(groupedSubjects).map(key => {
        return (
          <div key={key}>
            <TitleLabel>{getClassName(groupedSubjects[key])}</TitleLabel>
            <div className="subjects">
              {groupedSubjects[key].map(elem => {
                return (
                  <div className="subject" key={elem.subject_id}>
                    <Link
                      className="btn nowrap shadow subject-button bg-white no-underline text-bold"
                      to={`/study/details/${elem.teaching_structure_id}?title=${elem.teaching_structure.title}&class=${elem.teaching_structure.parent.id}`}
                    >
                      <div>{elem.teaching_structure.title} </div>
                      <Eye color="var(--eye-icon-color)" fontSize="0.9375rem" />
                    </Link>
                    <h4 className="created-at">
                      {getFormatedDate(elem.teaching_structure.parent.created_at)}
                    </h4>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default PrintSubjects;
